import store from '../store';
import router from '../router';
import webRTC from './webrtc';
import mobile from './mobile';
import { eBus } from "./eventBus";
import screenShare from "./screenshare";
import utils from './utils';
import config from '../config';

export async function onMessage(resp) {
  console.debug(`[ ${resp.eventOp ? resp.eventOp : resp.signalOp} ] Signal -> Web `, resp);
  if (config.privateMode.switch && resp.code === '412') {
    return eBus.$emit('popup', {
      on: true,
      type: 'Alert',
      title: '회의 참여',
      contents: '잘못된 경로로 접근하였습니다. 초기화면으로 이동합니다.',
      cancel: () => {
        window.location.href = utils.getPrivateUrl();
      }
    })
  }

  if (resp.code === '504') {
    eBus.$emit(Object.keys(store.state.roomInfo).length ? 'popup' : 'popup-main', {
      on: true,
      type: 'Alert',
      title: '서버 오류',
      contents: '서버와의 연결이 원활하지 않습니다. 잠시 후 다시 시도해주세요.',
      cancel: () => {
        window.location.href = utils.getPrivateUrl();
      }
    });
  }

  //AudioSafe 관리 객체
  let audioSafeStatus = {};

  switch (resp.eventOp || resp.signalOp) {
    case 'CreateRoom':
      if (resp.code === '200') {
        //210218 add Entrance page 
        store.commit('setRoomInfo', { roomId: resp.roomId, isHost: true });
        router.push({ path: `${resp.cp ? '/' + resp.cp : ''}/entrance/${resp.roomId}` });
      }
      break;
    
    case 'RoomJoin':
      //210218 add Entrance page 
      receiveRoomJoin(resp);
      break;
      
    //210218 add Entrance page
    case 'RoomJoinWithName':
      receiveRoomJoin(resp);
      break;
    
    case 'StartSession':
      sendMessage('StartSession', { code: '200' });
      if (resp.members) {
        store.commit('setRoomInfo', {
          members: resp.members,
          count: Object.keys(resp.members).length,
          type: resp.useMediaSvr === 'Y' ? 'multi' : 'p2p',
          // host: resp.host
        });
        cocolib.audioSafe.update(store.state.roomInfo.count);
        let members = Object.keys(resp.members);
        //210202 mz, videoOnMembers 위치 변경 (RoomJoin, StartSession, Presence Op --> Peer connected)
        // let idx = members.indexOf(store.state.userInfo.id)
        // if(idx > 0){
        //   members.splice(members.indexOf(store.state.userInfo.id),1);
        //   members.splice(0,0,store.state.userInfo.id);
        // }
        // store.commit('setVideoOnMembers', members);
      }
      if (resp.useMediaSvr === 'Y') {
        if (resp.changeView || resp.who === store.state.userInfo.id) {
          // 200619 ivypark, v0.9.3. 1:1 -> N:N 전환 시 화면공유 종료 (stream이 3번째 사용자에게 전달 되지 않음. 끊는 것이 날리지톡 정책)
          if (store.state.streamInfo.screen) {
            eBus.$emit('share', { type: 'remove' });
            eBus.$emit('popup', { on: true, type: 'Alert', title: '화면 공유', contents: '다자 통화 화면 전환으로 인해 화면공유가 종료됩니다.' });
          }

          //when blur is on
          if(store.state.videoStatus['local'] && store.state.videoStatus['local'].blur){
            eBus.$emit('popup', { on: true, type: 'Alert', title: '사생활 보호', contents: '다자 통화 화면 전환으로 인해 사생활 보호가 종료됩니다.' });
            eBus.$emit('blurStop',{});
          }

          // 210303 모바일웹 종료 이슈 수정
          store.commit('removeStreamInfo', 'remote');
          store.commit('removePeerInfo', 'local');
          await webRTC.createPeer('local', resp.useMediaSvr === 'Y', undefined, resp.host);
          await webRTC.createOffer('local');
        }
      } else {
        await webRTC.createPeer('local', resp.useMediaSvr === 'Y', undefined, resp.host);
        await webRTC.createOffer('local');
      }
      break;

    case 'SDP':
      if (resp.code === '200') return;
      if (resp.usage === 'cam') {
        if (resp.sdp.type === 'offer') {
          await webRTC.createPeer(resp.useMediaSvr === 'N' ? 'local' : resp.displayId, resp.useMediaSvr === 'Y', resp.pluginId);
          await webRTC.createAnswer(resp.sdp, resp.useMediaSvr === 'N' ? 'local' : resp.displayId);
          sendMessage('SDP', { code: '200' });
        } else if (resp.sdp.type === 'answer') {
          await webRTC.setRemoteDescription(resp.sdp, 'local');
          sendMessage('SDP', { code: '200' });
        }
      } else if (resp.usage === 'screen') {
        if (resp.sdp.type === 'offer') {
          await screenShare.createPeer('screen', resp.useMediaSvr === 'Y', resp.pluginId);
          await webRTC.createAnswer(resp.sdp, 'screen');
          sendMessage('SDP', { code: '200' });
        } else if (resp.sdp.type === 'answer') {
          await webRTC.setRemoteDescription(resp.sdp, 'screen');
          sendMessage('SDP', { code: '200' });
        }
      }
      break;

    case 'Candidate':
      if (resp.usage === 'cam') {
        if (resp.candidate) await webRTC.setCandidate(resp.candidate, resp.useMediaSvr === 'N' ? 'local' : resp.userId);
        sendMessage('Candidate', { code: '200' });
      }
      break;

    case 'ReceiveFeed':
      // 210208, 0.5초당 1개의 sendfeed 전송
      resp.feeds.forEach((curr, idx) => {
        (function (c, i) {
          setTimeout(function () {
            sendMessage('SendFeed', { roomId: resp.roomId, feedId: c.id, display: c.display });
          }, 500 + (500 * i));
        })(curr, idx);
      });
      // TODO: 200728 ivypark, functionalization
      // resp.feeds.forEach(curr => {
      //   sendMessage('SendFeed', { roomId: resp.roomId, feedId: curr.id, display: curr.display });
      // })
      break;

    case 'SendFeed':
      // TODO.
      break;

    case 'SessionReserve':
      if (resp.code === '200') {
        let stream = await screenShare.createShareStream();
        await screenShare.createPeer('screen', store.state.roomInfo.count > 2);
        await webRTC.createOffer('screen');
        eBus.$emit('share', {
          type: 'add',
          id: 'screen',
          isLocal: true,
          stream,
          count: store.state.roomInfo.count
        })
      } else {
        eBus.$emit('popup', {
          on: true,
          type: 'Alert',
          title: '화면 공유',
          contents: '지금은 화면 공유를 진행할 수 없습니다.'
        })
      }
      break;

    case 'ScreenShareConferenceEndSvr':
      eBus.$emit('share', {
        type: 'remove'
      })
      break;

    case 'EditFeed':
      // 210202 mz, add EditFeed 422 err
      if (resp.code === '422') {
        console.error('EditFeed error! 422 :', resp);
        return;
      }
      if (resp.code === '200' && resp.video === true) {
        eBus.$emit('networkCondition', {
          isGood : true,
          userId : resp.userId
        });
      } else if (resp.code === '200' && resp.video === false) {
        eBus.$emit('networkCondition', {
          isGood : false,
          userId : resp.userId
        });
      }
      break;

    case 'Presence':
      if (resp.action === 'exit') {
        let beforeCnt = store.state.roomInfo.count;
        let members = store.state.roomInfo.members;
        delete members[resp.userId];
        store.commit('setRoomInfo', { members: members, count: store.state.roomInfo.count - 1 });

        let videoOnMembers = store.state.videoOnMembers;
        let videoOffMembers = store.state.videoOffMembers;
        let videoOnIdx = videoOnMembers.indexOf(resp.userId);
        let videoOffIdx = videoOffMembers.indexOf(resp.userId);
        if(videoOnIdx>-1){
          videoOnMembers.splice(videoOnIdx,1);
          store.commit('setVideoOnMembers', videoOnMembers);
        }

        if(videoOffIdx>-1){
          videoOffMembers.splice(videoOffIdx,1);
          store.commit('setVideoOffMembers', videoOffMembers);
        }


        //화자감지 on 중 일대일 회의로 전환 시 처리
        if (store.state.showsSpeaker && beforeCnt > 2 && store.state.roomInfo.count == 2){
          eBus.$emit('popup', {
            on: true,
            type: 'Alert',
            title: '화자 감지',
            contents: '일대일 회의 시 화자감지 기능이 종료됩니다.'
          });
          eBus.$emit('showsSpeaker', {
            setShows : false,
          });
        }

        //사생활보호 중 일대일 회의로 전환 시 처리
        if(store.state.roomInfo.count === 2 && store.state.videoStatus['local'] && store.state.videoStatus['local'].blur ){
          eBus.$emit('blurAgain', {});
        }

        //사생활보호 중 혼자 남아있을 경우
        if(store.state.roomInfo.count <= 1 && store.state.videoStatus['local'] && store.state.videoStatus['local'].blur ){
          eBus.$emit('popup', {
            on: true,
            type: 'Alert',
            title: '사생활 보호',
            contents: '다른 모든 사용자가 통화를 종료하여 사생활 보호가 종료됩니다.'
          })

          eBus.$emit('blurStop', {});
        }

        if (store.state.roomInfo.count <= 1 && store.state.peerInfo.hasOwnProperty('screen')) {
          eBus.$emit('share', {
            type: 'remove',
            isSharer: true
          })
          eBus.$emit('popup', {
            on: true,
            type: 'Alert',
            title: '화면 공유',
            contents: '다른 모든 사용자가 통화를 종료하여 화면공유가 종료됩니다.'
          })
        }

        eBus.$emit('video', {
          type: 'remove',
          count: store.state.roomInfo.count,
          id: store.state.roomInfo.type === 'p2p' ? 'remote' : resp.userId
        })

        cocolib.audioSafe.update(store.state.roomInfo.count);
      } else if (resp.action === 'join') {
        if (resp.members) store.commit('setRoomInfo', { members: resp.members, count: Object.keys(resp.members).length });
        //210202 mz, videoOnMembers 위치 변경 (RoomJoin, StartSession, Presence Op --> Peer connected)
        // let members = store.state.videoOnMembers;
        if(resp.userId) {
          // members.push(resp.userId);
          // store.commit('setVideoOnMembers', members);
          store.commit('setVideoStatus', {userId: resp.userId, cam: true, audioSafe: false});
        }
      } else if (resp.action === 'talking') {
        //화자감지 이벤트 수신
        if (store.state.showsSpeaker && store.state.roomInfo.count > 2 && store.state.roomInfo.members[resp.userId]){
          eBus.$emit('showsSpeaker', {
            isTalking : resp.talking,
            userId : resp.userId === store.state.userInfo.id ? 'local' : resp.userId
          })
        }
      } else if (resp.action === 'slowLink') {
        eBus.$emit('networkCondition', {
          isGood : !resp.status,
          userId : resp.userId
        })

      }
      break;

    case 'ChangeName':
      eBus.$emit('video', {
        type: 'set',
        id: store.state.roomInfo.type === 'p2p' ? 'remote' : resp.userId,
        name: resp.name
      })
      break;

    case 'SetAudio':
      store.state.roomInfo.members[resp.userId].AUDIO = resp.status;
      eBus.$emit('video', {
        type: 'set',
        id: store.state.roomInfo.type === 'p2p' ? 'remote' : resp.userId,
        isOffMic: resp.status
      })
      break;

    case 'SetVideo':
      store.state.roomInfo.members[resp.userId].VIDEO = resp.status;
      if(store.state.roomInfo.type === 'p2p'){
        eBus.$emit('video', {
          type: 'set',
          id: 'remote',
          isOffVideo: resp.status
        });
        return ;
      }

      //상태 관리
      if(store.state.videoStatus[resp.userId] && store.state.videoStatus[resp.userId].audioSafe){
        audioSafeStatus[resp.userId] = store.state.videoStatus[resp.userId].audioSafe;
      } else {
        audioSafeStatus[resp.userId] = false;
      }
      store.commit('setVideoStatus',{userId:resp.userId, cam: !resp.status, audioSafe: audioSafeStatus[resp.userId]});

      if(!audioSafeStatus[resp.userId]){
        eBus.$emit('video', {
          type: 'set',
          id: resp.userId,
          isOffVideo: resp.status
        })
      }

      break;

    case 'Talking':
      eBus.$emit('video', {
        type: 'set',
        id: store.state.roomInfo.type === 'p2p' ? 'remote' : resp.userId,
        isTalking: resp.status
      })
      break;
  }
}

function receiveRoomJoin(resp) {
  if (resp.code === '400') {
    return eBus.$emit('popup-enter', {
      on: true,
      type: 'Alert',
      title: '회의 참여',
      contents: '회의 방이 만료되었습니다. 초기 화면으로 이동합니다.',
      cancel: () => {
        window.location.href = '/';
      }
    })
    // 210202 mz, 16인 제한, 444 error 적용
  } else if (resp.code === '444') {
    return eBus.$emit('popup-enter', {
      on: true,
      type: 'Alert',
      title: '회의 참여', 
      contents: '회의 방의 인원이 초과되어 입장할 수 없습니다.',
      cancel: () => {
        window.location.href = '/';
      }
    })
  }
  store.commit('setUserInfo', { id: resp.userId, name: store.state.userInfo.name ? store.state.userInfo.name : '익명' });
  store.commit('setResolution', resp.resolution);
  if (resp.members) {
    store.commit('setRoomInfo', {
      members: resp.members,
      roomId: resp.roomId,
      count: Object.keys(resp.members).length,
      type: Object.keys(resp.members).length > 2 ? 'multi' : 'p2p'
    });
    //210202 mz, videoOnMembers 위치 변경 (RoomJoin, StartSession, Presence Op --> Peer connected)
    // let members = Object.keys(resp.members);
    // if(members.length>1){
    //   members.splice(members.indexOf(resp.userId),1);
    //   members.splice(0,0, resp.userId);
    //   store.commit('setVideoOnMembers', members);
    // }
  }
  router.replace({path: `${resp.cp ? '/' + resp.cp : ''}/room/${resp.roomId}`});
}

export function sendMessage(op, data = {}, type = 'eventOp') {
  let obj = {};
  obj[type] = op;
  if(op!=='KeepAlive'){
    obj['cpCode'] = config.privateMode.cpCode[config.env];
    obj['authKey'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoi64Kg66as7KeA7Y-s7J247Yq4IiwibWF4VXNlciI6IjUwMDAwMDAwIiwic3RhcnREYXRlIjoiMjAyMC0wMS0wMVQwNjo0NzowMC4wMDBaIiwiZW5kRGF0ZSI6IjIwMzAtMTItMzFUMDY6NDc6MDAuMDAwWiIsImF1dGhDb2RlIjoiS1AtMjAyMDAxMDEtMDEiLCJjb21wYW55Q29kZSI6IkxJQy0wMSIsImlhdCI6MTU4NzUzODExNH0.73A0UiiMHJeIS8pIgoN4DfEWT4QCsMnXkO4uUdnfbYI';
  }
  Object.assign(data, obj);
  console.debug(`[ ${op} ] Web -> Signal `, data);
  store.state.socket.emit('knowledgetalk', data);
}



// WEBPACK FOOTER //
// ./src/commons/message.js